module.exports = __webpack_public_path__ + "static/media/03.a16783ca.mp4";